module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category-content"
  }, [_c('div', {
    staticClass: "main-width"
  }, [_c('div', {
    staticClass: "promotions-item"
  }, [_c('div', {
    staticClass: "promotions-item-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgAddress + _vm.active.picturePath
    },
    on: {
      "error": function($event) {
        return _vm.error(3)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "promotions-item-content"
  }, [_c('div', {
    staticClass: "promotions-item-title"
  }, [_vm._v(_vm._s(_vm.active.title))]), _vm._v(" "), _c('div', {
    staticClass: "promotions-item-time"
  }, [_c('label', [_vm._v("活动开始时间：" + _vm._s(_vm.active.startTime))])]), _vm._v(" "), _c('div', {
    staticClass: "promotions-item-time"
  }, [_c('label', [_vm._v("活动结束时间：" + _vm._s(_vm.active.endTime))])]), _vm._v(" "), (_vm.active.remark == '') ? _c('div', {
    staticClass: "promotions-item-remark"
  }, [_vm._v("\n\t\t\t\t\t无\n\t\t\t\t")]) : _c('div', {
    staticClass: "promotions-item-remark"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.active.remark) + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "font-right promotions-update-time"
  }, [_vm._v("时间：" + _vm._s(_vm.active.releaseTime))])])]), _vm._v(" "), (_vm.condition.activityId != 0 && _vm.goodsList.length != 0) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "category-check-wrap mar-bot-20"
  }, [_c('span', {
    staticClass: "category-check-name"
  }, [_vm._v("供应商筛选：")]), _vm._v(" "), _c('span', {
    staticClass: "category-check-item",
    on: {
      "click": _vm.setTax
    }
  }, [_c('span', {
    staticClass: "category-check-default",
    class: {
      'promotions-check': _vm.condition.isBill
    }
  }), _vm._v("\n\t\t\t\t\t\t带票\n\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "category-check-item",
    on: {
      "click": _vm.setTax
    }
  }, [_c('span', {
    staticClass: "category-check-default",
    class: {
      'promotions-check': !_vm.condition.isBill
    }
  }), _vm._v("\n\t\t\t\t\t\t不带票\n\t\t\t\t\t")]), _vm._v(" "), _c('a', {
    staticClass: "promotions-shortcut",
    on: {
      "click": _vm.pushAll
    }
  }, [_vm._v("一键参与活动")])]), _vm._v(" "), _c('div', {
    staticClass: "promotions-goods"
  }, [_c('ul', {
    staticClass: "category-goods-list"
  }, _vm._l((_vm.goodsList), function(item, index) {
    return _c('li', {
      staticClass: "category-goods-item"
    }, [_c('div', {
      staticClass: "category-goods-image",
      on: {
        "mouseenter": function($event) {
          return _vm.showMask(index)
        },
        "mouseleave": function($event) {
          return _vm.hideMask(index)
        }
      }
    }, [_c('router-link', {
      attrs: {
        "tag": "a",
        "target": "_blank",
        "to": {
          name: 'Detail',
          query: {
            goodsId: item.goodsId,
            activityId: _vm.condition.activityId
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.imgAddress + item.goodsImage
      },
      on: {
        "error": function($event) {
          return _vm.error(1)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "category-hover-product",
      class: {
        'display-none': _vm.maskShow[index].isShow
      }
    }, [_c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("SKU")]), _vm._v(" "), _c('th', [(_vm.condition.isBill == 0) ? _c('span', [_vm._v("不带票结算价")]) : _c('span', [_vm._v("带票/不带票")])]), _vm._v(" "), _c('th', [_vm._v("库存")])])]), _vm._v(" "), _c('tbody', _vm._l((item.products), function(value, index) {
      return (index < 5) ? _c('tr', [_c('td', {
        staticClass: "category-table-SKU"
      }, [_c('div', [_vm._v(_vm._s(value.specName))])]), _vm._v(" "), _c('td', [(_vm.condition.isBill == 0) ? _c('span', [_vm._v(_vm._s(value.noTaxSettlementPrice / 100))]) : _c('span', [_vm._v(_vm._s(value.taxSettlementPrice / 100) + "/" + _vm._s(value.noTaxSettlementPrice / 100))])]), _vm._v(" "), _c('td', [(_vm.condition.isBill == 0) ? _c('span', [_vm._v(_vm._s(value.inventoryNum))]) : _c('span', [_vm._v(_vm._s(value.taxInventoryNum))])])]) : _vm._e()
    }), 0)])])])], 1), _vm._v(" "), _c('div', {
      staticClass: "category-goods-money promotions"
    }, [_vm._v("利润率：" + _vm._s(item.profitMargin) + "%")]), _vm._v(" "), _c('div', {
      staticClass: "category-goods-info"
    }, [_c('div', {
      staticClass: "category-goods-price promotions"
    }, [_vm._v("¥" + _vm._s(item.salePrice / 100)), _c('span', [_vm._v("佣金：¥" + _vm._s(item.commission / 100))])]), _vm._v(" "), _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "placement": "top"
      }
    }, [_c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_vm._v(_vm._s(item.goodsName))]), _vm._v(" "), _c('div', {
      staticClass: "category-goods-title"
    }, [(item.channel == 1) ? _c('div', {
      staticClass: "promotions-goods-channel"
    }, [_vm._v("电商")]) : (item.channel == 2) ? _c('div', {
      staticClass: "promotions-goods-channel"
    }, [_vm._v("门店")]) : _c('div', {
      staticClass: "promotions-goods-channel"
    }, [_vm._v("海淘")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.goodsName) + "\n\t\t\t\t\t\t\t\t\t")])])], 1), _vm._v(" "), (_vm.condition.isBill == 0) ? _c('div', [(_vm.noInventoryNum[index].haskc == 0) ? _c('div', {
      staticClass: "category-goods-add-default yishangjia"
    }, [_vm._v("暂无库存")]) : (item.shelves == 0) ? _c('div', {
      staticClass: "category-goods-add-default promotions",
      on: {
        "click": function($event) {
          return _vm.addGoodsAll(index, item.goodsId)
        }
      }
    }, [_vm._v("参与活动")]) : _c('div', {
      staticClass: "category-goods-add-default yishangjia"
    }, [_vm._v("已参与活动")])]) : _c('div', [(_vm.noTaxInventoryNum[index].haskc == 0) ? _c('div', {
      staticClass: "category-goods-add-default yishangjia"
    }, [_vm._v("暂无库存")]) : (item.shelves == 0) ? _c('div', {
      staticClass: "category-goods-add-default promotions",
      on: {
        "click": function($event) {
          return _vm.addGoodsAll(index, item.goodsId)
        }
      }
    }, [_vm._v("参与活动")]) : _c('div', {
      staticClass: "category-goods-add-default yishangjia"
    }, [_vm._v("已参与活动")])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.condition.pageNum,
      "total": _vm.total,
      "page-size": 30
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.condition, "pageNum", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.condition, "pageNum", $event)
      }
    }
  })], 1)])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "promotions-split"
  }, [_c('div', {
    staticClass: "promotions-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "promotions-split-name"
  }, [_c('div', {
    staticClass: "promotions-cn"
  }, [_c('span', [_vm._v("营销商品")])]), _vm._v(" "), _c('div', {
    staticClass: "promotions-en"
  }, [_c('span', [_vm._v("G-CLOUD PROFILE")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23ddc07c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PromotionsDetail.vue
// module id = 522
// module chunks = 1